import { FC, useContext } from "react";
import { FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import { FormProvider, useForm } from "react-hook-form";
import { TestRegistryListFooter } from "./TestRegistryListFooter";
import { TestRegistryItem } from "./TestRegistryItem";
import { TestContext } from "../../store/testContext";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getItems } from "src/modules/spItems/actions";
import { answersRegistry, notificationTestsAnswers, notificationTestsQuestion, questionsRegistry, testRegistry } from "src/api/config/notifications.config";
import { selectItems } from "src/modules/spItems/selectors";
import { getItemsRequest } from "src/modules/spItems/api";
import { addQuestion } from "../../store/testActions";

interface IProps {
  openModalAddTest: () => void;
  testName: string;
  selectedCollection: any;
  testsList: any[];
}

export const TestRegistryList: FC<IProps> = ({ openModalAddTest, selectedCollection, testName, testsList }) => {
  const methods = useForm();
  const { handleSubmit } = methods;

  const { dispatch } = useContext(TestContext);

  const getAnswers = async (answers: any) => {
    const answersList = await getItemsRequest({
      listName: answersRegistry,
      filters: { ID: answers }
    });

    const answersItems = answersList.items;

    return answersItems.map(answer => {
      return {
        ID: String(answer.ID),
        Description: answer.Description,
        IsCorrect: answer.IsCorrect
      };
    });
  };

  const onSubmit = async (e: any) => {
    if (!e.TestID) return;
    const questionsTest = testsList.find(test => test.ID === +e.TestID);

    const questions = await getItemsRequest({
      listName: questionsRegistry,
      filters: { ID: questionsTest.QuestionsID.map((question: any) => question.ID) }
    });

    const testQuestions = await Promise.all(
      questions.items.map(async question => {
        const answers = await getAnswers(question.Answers.map((answer: any) => answer.get_lookupId()));

        return {
          ID: String(question.ID),
          Description: question.Description,
          Type: question.TypeQuestion,
          Answers: answers
        };
      })
    );

    testQuestions.map(question => dispatch(addQuestion(question)));
  };

  const cleanedTestName = testName.replace(/\s+/g, "").toLowerCase();
  const filteredListTests = testsList.filter(
    (test: any) =>
      (cleanedTestName.length === 0 || test.Title.toLowerCase().includes(cleanedTestName)) && (Object.keys(selectedCollection).length === 0 || test.Collections.Title === selectedCollection.Title)
  );
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FlexRow className={twMerge("text-black", "flex flex-col items-center justify-between p-9 pt-0 flex-nowrap font-medium")}>
          {filteredListTests.map(test => (
            <TestRegistryItem test={test} key={test.ID} />
          ))}
        </FlexRow>

        <TestRegistryListFooter testsList={testsList} openModalAddTest={openModalAddTest} />
      </form>
    </FormProvider>
  );
};
